
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class SupersedableProductPlanDtoModel extends Model<SupersedableProductPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'guid', languageString: 'supersedableProductPlanDto.property.productPlanId' },
		{ name: 'accountingPlanId', type: 'guid', languageString: 'supersedableProductPlanDto.property.accountingPlanId' },
		{ name: 'remainingValue', type: 'number', languageString: 'supersedableProductPlanDto.property.remainingValue' },
		{ name: 'maxAdjustmentValue', type: 'number', languageString: 'supersedableProductPlanDto.property.maxAdjustmentValue' },
		{ name: 'suspended', type: 'boolean', languageString: 'supersedableProductPlanDto.property.suspended' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public accountingPlanId?: string;
	public remainingValue: number;
	public maxAdjustmentValue: number;
	public suspended: boolean;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.accountingPlanId = undefined;
		this.remainingValue = 0;
		this.maxAdjustmentValue = 0;
		this.suspended = false;
		
	}
	getProperties(){
		return SupersedableProductPlanDtoModel.classProperties;
	}
}

